import { DataGrid } from '@ijoin/components';
import { useGetAnnuityCarriers } from '@ijoin/hooks';
import { Stack, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { createFileRoute } from '@tanstack/react-router';

import { camelCase } from 'lodash';

import { LinkButton } from '../../components';

type Carrier = {
  annuityIntegrationId: string;
  description: string;
};

const Page = () => {
  const carriers = useGetAnnuityCarriers();

  const columns: GridColDef<Carrier>[] = [
    {
      field: 'description',
      flex: 1.2,
      headerName: 'Carrier',
      renderCell: params => (
        <LinkButton
          data-testid={camelCase(params.row.description)}
          params={{ annuityIntegrationId: params.row.annuityIntegrationId }}
          to='/carriers/$annuityIntegrationId'
          variant='text'>
          {params.value}
        </LinkButton>
      )
    }
  ];

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>Annuity Carriers</Typography>

      <DataGrid
        autoHeight={false}
        columns={columns}
        disableColumnMenu
        disableRowSelectionOnClick
        getRowId={row => row.annuityIntegrationId}
        initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
        loading={carriers.isFetching}
        pageSizeOptions={[10, 25, 50, 100]}
        rows={carriers.data ?? []}
        showColumnMenu
        slotProps={{
          root: {
            'data-component': 'dataGrid',
            'data-testid': 'carriers'
          }
        }}
        sx={{ flex: 1, minHeight: 0 }}
      />
    </Stack>
  );
};

export const Route = createFileRoute('/carriers/')({
  component: Page
});
